import React from "react";
//** MUI Components */
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PropTypes from "prop-types";
import useTheme from "@mui/material/styles/useTheme";

//----------------------------------------------------------------

export default function NotificationCard({ sx, ...props }) {
  const {
    cardType = "error",
    title = null,
    alignIcon = "center",
    ...rest
  } = { ...props };
  const theme = useTheme();

  //** Set the the card colour based on type */
  const getCardColours = (cardType) => {
    switch (cardType) {
      case "error":
        return {
          borderColor: theme.palette.signal.Error500,
          backGroundColor: theme.palette.signal.Error050,
        };
      case "info":
        return {
          borderColor: theme.palette.signal.Info500,
          backGroundColor: theme.palette.signal.Info050,
        };
      case "warning":
        return {
          borderColor: theme.palette.signal.Warning500,
          backGroundColor: theme.palette.signal.Warning050,
        };
      case "success":
        return {
          borderColor: theme.palette.signal.Success500,
          backGroundColor: theme.palette.signal.Success050,
        };

      default:
        break;
    }
  };

  //** Load the the card icon based on type */
  const getCardIcon = (cardType) => {
    switch (cardType) {
      case "error":
        return (
          <ReportProblemIcon sx={{ color: theme.palette.signal.Error500 }} />
        );
      case "info":
        return <InfoIcon sx={{ color: theme.palette.signal.Info500 }} />;
      case "warning":
        return <ErrorIcon sx={{ color: theme.palette.signal.Warning500 }} />;
      case "success":
        return (
          <CheckCircleIcon sx={{ color: theme.palette.signal.Success500 }} />
        );
      default:
        break;
    }
  };

  const sxCard = (cardType) => {
    const cardColors = getCardColours(cardType);
    return {
      border: `2px solid`,
      borderColor: cardColors.borderColor,
      borderRadius: 2,
      backgroundColor: cardColors.backGroundColor,
      padding: 3,
      display: "flex",
      justifyContent: "flex-Start",
      alignItems: "flex-start",
      textAlign: "left",
      ...sx,
    };
  };

  let {
    icon = getCardIcon(cardType),
    // title = `Title of ${cardType}:`,
    titleVariant = "p2-bold",
    message = "Place your message here lorem",
    messageVariant = "p2",
    additionalText = null,
  } = { ...rest };

  return (
    <Card sx={sxCard(cardType)}>
      <Stack>
        <Stack direction={"row"} spacing={2} alignItems={alignIcon} mb={1}>
          {icon}
          {title && <Typography variant={titleVariant}>{title}</Typography>}
          {message && !title && (
            <Typography sx={{ textAlign: "left" }} variant={messageVariant}>
              {message}
            </Typography>
          )}
        </Stack>
        <Stack sx={{ ml: 5 }}>
          {title && (
            <Typography sx={{ textAlign: "left" }} variant={messageVariant}>
              {additionalText && (
                <Typography
                  sx={{ textAlign: "left", fontWeight: "bold" }}
                  variant={messageVariant}
                >
                  {additionalText}{" "}
                </Typography>
              )}
              {message}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}

NotificationCard.propTypes = {
  cardType: PropTypes.oneOf(["error", "success", "info", "warning"]),
};

NotificationCard.defaultProps = {
  cardType: "error",
  title: "Card Title",
};
